import styled from 'styled-components';

const Heading = styled.h1`
font-size: 2.5rem;
font-weight: 100;
`;

export default Heading;